import React, { Component } from 'react';
import { Table, Divider, Tag, Icon, Button, Card, Row ,Col} from 'antd';


export default class Card2 extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };

    }

    render() {
        const { img, title, detail } = this.props;

        return (
            <Card className="card2">
                <Row>
                    <Col xs={8} sm={8} md={8} lg={8} xl={8} style={{ textAlign: 'right' }}>
                        <img src={img} />
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={0} xl={1}>
                    </Col>
                    <Col xs={16} sm={16} md={16} lg={16} xl={15}>
                        <h1>{title}</h1>
                        <label>{detail}</label>
                    </Col>
                </Row>
            </Card>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Ants/Card/Card2.js